  <div class="new-landing-page-info common-headermargin bg-white-clr">
      <!-- Start First Section -->
      <section class="landing-page-first-section first-section-content bg-img-first-section">
        <div class="container">
          <div class="left-bgimage-first-section">
            <div class="colm-right">
              <img src="assets/img/left-bg-img-2nd-vector.png" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="colm-left">
                <img src="assets/meander.png" alt="Logo" class="header-image-logo" />
                <h1>Welcome to Meander Live!</h1>
                <p>Meander Software is Product based Software Company primarily focused on delivering B2B & B2C solutions accessed via Web & Mobile Platforms. 
                </p>
                <div class="d-flex flex-sm-row flex-column">
                  <a class="btn-getstarted btn bg-light-primary mb-2 mr-3 mb-sm-0" [routerLink]="'/connect-to-learn'">Connect To Learn</a>
                  <a class="btn-getstarted btn btn-primary" [routerLink]="'/login'">Login</a>
                </div>
                <!-- <a class="btn-getstarted cursor">Get Started</a> -->
              </div>
            </div>
          </div>
          <div class="right-image-first-section">
            <div class="colm-right">
              <img src="assets/img/image-mspl.png" />
            </div>
          </div>
        </div>
      </section>
      <!-- End First Section -->
  
      <!-- Start Second Section -->
      <section class="landing-page-second-section second-section-content bg-img-second-section">
        <!-- <div class="right-bg-img-1st">
          <div class="colm-right">
            <img src="assets/img/group-5825.png" />
          </div>
        </div> -->
        <div class="container">
          <div class="row equal mb-40px">
            <div class="col-md-6">
              <div class="colm-left bg-clr-seam-disc">
                <h2 class="clr-pink mb-20px">Awards & Recognition </h2>
                <p class="mb-35px">Latest news, tips and best awards.</p>
                <style>
                  ul.ul-tag-reviews-img li::before {
                    content: url(assets/star-yellow-icon.png);
                  }
  
                </style>
                <ul class="ul-tag-reviews-img">
                  <!-- <li>The Best Product Award In 2016</li>
                  <li>2016 IEEE CS TCSE Rising Star Award</li>
                  <li>Best Industrial Training Award in 2019</li> -->
                  <li>YOUNGEST ENTREPRENEUR STPI - 2012</li>
                  <li>ISO 20000-1 : 2018 CERTIFIED</li>
                  <li>NASSCOM BEST SHORTLISTED PRODUCT - 2019</li>
                  <li>EMERGING TECHNOLOGY PARTNERS - 2021</li>
                  <!-- <li>RECOGNISED BY MSME, SHOP REGULATIONS AND MCA GOVERNMENT BODIES</li>
                  <li>1 MILLION+ HOUR’S SOFTWARE PRODUCTS DELIVERED ON REPUTED MARKETPLACES</li> -->
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="colm-right">
                <img class="seamless-disc-img" src="assets/img/image2.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="left-bg-img-2nd">
          <div class="colm-right">
            <img src="assets/img/group-9246.svg" />
          </div>
        </div>
        <div class="container">
          <div class="row equal pb-90px align-items-center">
            <div class="col-md-6 order-change-mob">
              <div class="colm-right">
                <img class="pers-activity-img" src="assets/img/image4.png" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="colm-left bg-clr-pers-activity">
                <h2 class="clr-purple mb-35px">Why Choose  US?</h2>
                <p>We are a reference in the high profile Software development company that addresses international markets and customers from all over the world</p>
                <p>We match ingenuity with the latest technologies to make incredible products. Together we create positive & long-lasting change.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="right-bg-img-3rd">
          <div class="colm-right">
            <img src="assets/img/right-bg-img-3rd-vector.png" />
          </div>
        </div>
        <!-- <div class="right-bg-img-4th">
          <div class="colm-right">
            <img src="assets/group-5826.png" />
          </div>
        </div> -->
        <div class="container">
          <div class="row equal pb-90px">
            <div class="col-md-6">
              <div class="colm-left bg-clr-bonus-content">
                <h2 class="clr-orange mb-35px">Our Portfolio</h2>
                <p>Here are some of the picture in our portfolio of the trainees who have completed their training successfully.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="colm-right">
                <img class="bonus-content-img" src="assets/img/image3.png" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Second Section -->
  
    </div>
    <app-footer></app-footer>